import {ReactiveFormsModule} from "@angular/forms";
import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-custom-input',
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './custom-input.html',
  styleUrl: './custom-input.css'
})
export class CustomInput {
  @Input() placeholder = 'Buscar...';
  @Input() value: string | null | number = null;

  @Output() valueChange = new EventEmitter<string | null>();

  @Output() enter = new EventEmitter<string | null | number>();

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.valueChange.emit(this.value);
  }

  onEnter() {
    this.enter.emit(this.value);
  }

}
